module.exports = __webpack_public_path__ + "a46544854f4c109d2a922e5e19b58b8c.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/butter.png
// module id = 590
// module chunks = 0